// removed by extract-text-webpack-plugin
module.exports = {"root":"SubscriptionsList__root--2Da6g","content":"SubscriptionsList__content---F__n","category":"SubscriptionsList__category--MP2A1","name":"SubscriptionsList__name--30geW","description":"SubscriptionsList__description--3t4qX","separator":"SubscriptionsList__separator--2WjoM","subscribe":"SubscriptionsList__subscribe--2jJ_X","bounce":"SubscriptionsList__bounce--3L-pM"};


//////////////////
// WEBPACK FOOTER
// ./src/subscriptions/components/SubscriptionsList/SubscriptionsList.css
// module id = ./src/subscriptions/components/SubscriptionsList/SubscriptionsList.css
// module chunks = 2